module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16wJ0yi/images/Cover.jpg?1717894407403",
      "alt": "This image is the cover for the book Motor City Movie Culture, 1916–1925"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Motor City Movie Culture, 1916–1925\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A study of how the film industry came to flourish in Detroit in the early years as locals were lured into the new picture theaters.")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Motor City Movie Culture, 1916–1925")]), _vm._v(" is a broad textured look at Hollywood coming of age in a city with a burgeoning population and complex demographics. Richard Abel investigates the role of local Detroit organizations in producing, distributing, exhibiting, and publicizing films in an effort to make moviegoing part of everyday life."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Tapping a wealth of primary source material—from newspapers, spatiotemporal maps, and city directories to rare trade journals, theater programs, and local newsreels—Abel shows how entrepreneurs worked to lure moviegoers from Detroit’s diverse ethnic neighborhoods into the theaters. Covering topics such as distribution, programming practices, nonfiction film, and movie coverage in local newspapers, with entr’actes that dive deeper into the roles of key individuals and organizations, this book examines how efforts in regional metropolitan cities like Detroit worked alongside California studios and New York head offices to bolster a mass culture of moviegoing in the United States.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard Abel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0